var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { PureComponent } from 'react';
import { arrowsDefaultProps } from './defaults';
import { DivTag } from '../../Utils/AtomicTag';
var Arrows = /** @class */ (function (_super) {
    __extends(Arrows, _super);
    function Arrows(props) {
        return _super.call(this, props) || this;
    }
    Arrows.prototype.render = function () {
        var _a = this.props, canPrev = _a.canPrev, canNext = _a.canNext, leftIcon = _a.leftIcon, rightIcon = _a.rightIcon, className = _a.className, onChange = _a.onChange, goPrev = _a.goPrev, goNext = _a.goNext, rest = __rest(_a, ["canPrev", "canNext", "leftIcon", "rightIcon", "className", "onChange", "goPrev", "goNext"]);
        var arrowsAtomics = [
            'absolute',
            'top-0',
            'transform',
            'translate-y-1/2',
            'flex',
            'justify-between',
            'box-border',
            'w-full',
            'h-full',
            'py-0',
            'px-px-15',
        ];
        var arrowsIconAtomics = [
            'w-px-24',
            'h-px-24',
            'rounded-full',
            'flex',
            'justify-center',
            'items-center',
            'opacity-40',
        ];
        var arrowsLightAtomics = arrowsIconAtomics.concat([
            'bg-white',
            'bg-gray-400',
            'cursor-pointer',
        ]);
        var arrowPrevStyle = canPrev ? arrowsLightAtomics : arrowsIconAtomics;
        var arrowNextStyle = canNext ? arrowsLightAtomics : arrowsIconAtomics;
        return (React.createElement(DivTag, __assign({ atomics: arrowsAtomics, className: "carousel-arrows" }, rest),
            React.createElement(DivTag, { atomics: arrowPrevStyle, className: className, onClick: function () {
                    if (canPrev) {
                        goPrev();
                    }
                } }, typeof rightIcon === 'string' ? (React.createElement("img", { className: "carousel-arrows-icon left-icon", src: rightIcon })) : (rightIcon)),
            React.createElement(DivTag, { atomics: arrowNextStyle, className: className, onClick: function () {
                    if (canNext) {
                        goNext();
                    }
                } }, typeof leftIcon === 'string' ? (React.createElement("img", { className: "carousel-arrows-icon right-icon", src: leftIcon })) : (leftIcon))));
    };
    Arrows.defaultProps = arrowsDefaultProps;
    return Arrows;
}(PureComponent));
export { Arrows };
